import styled from "styled-components";

export const Button = styled.div`
  background: ${props => props.background || props.theme.backgroundDark};
  height: 28px;
  border-radius: ${props => props.theme.br.lg};
  width: fit-content;
  align-items: center;

  .arrow-container {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: ${props => props.theme[props.iconBackground]};
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .arrow-img {
    width: 14px;
    height: 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
  }

  .arrow-img > .icon {
    width: 100%;
    height: 100%;
  }

  .rotate {
    transform: ${props => (props.active ? "rotate(-180deg)" : "")};
    transition: all 0.2s ease-in;
    padding-top: ${props => (props.active ? "0" : "2px")};
  }
  .fade {
    background: ${props => props.theme[props.iconBackground]};
    transition: all 0.2s ease-in;
  }

  .mr-18 {
    margin-right: 18px;
  }

  .ml-12 {
    margin-left: 12px;
  }

  .mt-4 {
    margin-top: 4px;
  }
`;
